
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/use-toast';
import { useAuth } from '@/hooks/useAuth';
import { Team } from '../types';

export function useTeamCreate() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (name: string) => {
      if (!user) throw new Error('User not authenticated');
      
      // Insert team with user_id
      const { data: teamData, error: teamError } = await supabase
        .from('teams')
        .insert({ 
          name,
          user_id: user.id 
        })
        .select('*')
        .single();
        
      if (teamError) throw teamError;
      
      // Insert user as admin of the team
      const { error: memberError } = await supabase
        .from('team_members')
        .insert({
          team_id: teamData.id,
          user_id: user.id,
          role: 'admin'
        });
        
      if (memberError) throw memberError;
      
      return teamData as Team;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teams'] });
      toast({
        title: "Team created",
        description: "Your team has been created successfully.",
      });
    },
    onError: (error: any) => {
      console.error('Create team error:', error);
      toast({
        title: "Error creating team",
        description: error.message || "There was an error creating the team.",
        variant: "destructive",
      });
    }
  });
}
